// extracted by mini-css-extract-plugin
export default {"tile":"style_tile__9PpU1","preview-label-val":"style_preview-label-val__H6YNB","button":"style_button__kHIko","reset-button":"style_reset-button__Z1whV"};